import { render, staticRenderFns } from "./BookBorrowing.vue?vue&type=template&id=26732935"
import script from "./BookBorrowing.vue?vue&type=script&lang=js"
export * from "./BookBorrowing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports